module.exports = __webpack_public_path__ + "static/media/sirene.44bc7df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/specialApplications/sirene.jpg
// module id = 222
// module chunks = 0